// src/utils/results/resultModePresentation.jsx
//
// Single source of truth for how a recording mode is presented to patients:
// its short label and icon. Shared by the results list/activity feed
// (ResultsPage) and the single-result detail views so a mode reads identically
// wherever it appears.

import React from "react";

import RespiratoryRate from "../../components/icons/RespiratoryRate";
import Pulmonology from "../../components/icons/Pulmonology";
import VoiceSelectionIcon from "../../components/icons/VoiceSelectionIcon";
import StackedLineChartIcon from "../../components/icons/StackedLineChartIcon";
import DirectionsWalkIcon from "../../components/icons/DirectionsWalkIcon";
import { RESULT_MODE_CONFIG } from "./resultModeConfig";

export function getResultModeLabel(variant, t) {
  if (variant === RESULT_MODE_CONFIG.spirometry.variant) {
    return t("results.modes.spirometry", "Spirometry");
  }

  if (variant === RESULT_MODE_CONFIG.manualAudio.variant) {
    return t("results.modes.manualAudio", "Manual Audio");
  }

  if (variant === RESULT_MODE_CONFIG.postExertion.variant) {
    return t("results.modes.postExertion", "Exertion");
  }

  if (variant === RESULT_MODE_CONFIG.sixMinuteWalk.variant) {
    return t("results.modes.sixMinuteWalk", "6-Minute Walk");
  }

  return t("results.modes.cardiopulmonary", "Vitals");
}

export function getResultModeIcon(variant) {
  if (variant === RESULT_MODE_CONFIG.spirometry.variant) return <Pulmonology />;
  if (variant === RESULT_MODE_CONFIG.manualAudio.variant) {
    return <VoiceSelectionIcon />;
  }
  if (variant === RESULT_MODE_CONFIG.postExertion.variant) {
    return <StackedLineChartIcon />;
  }
  if (variant === RESULT_MODE_CONFIG.sixMinuteWalk.variant) {
    return <DirectionsWalkIcon />;
  }

  return <RespiratoryRate />;
}
